import { getTotalChatDuration } from '@/components/ChatMain/components/Header/components/Timer/helpers'
import { ChatModel } from '@/models/chat.model'
import { all, put, spawn } from 'redux-saga/effects'
import { closeChatAction } from '../../handles/closeChatAction'
import { Chat } from '../../types'
import { onEndServiceHook } from './http/onEndServiceHook'
import { clearActiveChatAction } from '../../actions'
import { refreshChatsCountAction } from '../../handles'
import { update } from '../_http/chat'
import { findUserById, FindUserByIdResponse, updateOnFirebase } from '../_http/user'

export function* closeChatSaga(action: ReturnType<typeof closeChatAction.request>) {
  const { chat, userAuthenticated, isClearActiveChat, companyId } = action.payload
  try {
    updateChatDurationsOnClose(chat, userAuthenticated.id)
    const updatedData: Partial<Chat> = {
      id: chat.id,
      status: 'close',
      startDate: chat.startDate,
      endDate: chat.endDate,
      finishedBy: { id: userAuthenticated.id, name: userAuthenticated.name },
      durations: chat.durations,
      duration: getTotalChatDuration(chat.durations),
      fixedBy: null
    }
    updatedData.endDate = new Date().getTime()
    const { user }: FindUserByIdResponse = yield findUserById(userAuthenticated.id)
    const updatedAttendFor = user?.attendFor?.filter(campaignId => campaignId !== chat.campaignId) || []

    yield put(closeChatAction.success({ chat: { ...chat, ...updatedData } }))
    yield all([
      update(chat.id, { ...updatedData, updatedAt: updatedData.endDate }),
      updateOnFirebase(user.id, { attendFor: updatedAttendFor })
    ])
    yield put(refreshChatsCountAction())
    if (isClearActiveChat) yield put(clearActiveChatAction())
    yield spawn(onEndServiceHook, { ...chat, ...updatedData }, companyId)
  } catch (error) {
    console.error('Error when ending chat:', error)
    yield put(closeChatAction.failure(error))
  }
}

export function updateChatDurationsOnClose(activeChat: ChatModel, operatorId: string) {
  const operatorDuration = findOperatorDuration(activeChat, operatorId)
  if (operatorDuration) {
    const currentPeriod = operatorDuration.periods.at(-1)
    if (currentPeriod && !currentPeriod?.endTime) {
      currentPeriod.endTime = Date.now()
    }
  }
}

function findOperatorDuration(activeChat: ChatModel, operatorId: string) {
  const durations = activeChat?.durations ?? []
  const operatorDuration = durations.find(duration => duration.operatorId === operatorId)
  return operatorDuration
}
